import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {AppAlertService} from '../../../shared/services/app-alert/app-alert.service';
import {AppMessageService} from '../../../shared/services/app-message/app-message.service';
import {TranslateService} from '@ngx-translate/core';
import {TableLazyLoadEvent} from 'primeng/table';
import {CreateInstituationComponent} from '../create/create-instituation.component';
import {InstituationService} from '../services/institiuation.service';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-prices',
  templateUrl: './instituation.component.html',
  styleUrl: './instituation.component.scss',
})
export class InstituationComponent implements AfterViewInit {
  @ViewChild('instituationCreate')
  instituationComponent: CreateInstituationComponent;
  filterCollaps: boolean = false;
  first = 0;
  rows = 10;
  totalRecords: number;
  instituationList: any[] = [];
  activityOptions: any[] = [
    {label: 'Aktif', value: true},
    {label: 'Pasif', value: false},
  ];
  filter: {
    search: string;
    startDate: Date | null;
    endDate: Date | null;
    isActive: boolean | null;
  } = {
    search: '',
    isActive: null,
    startDate: null,
    endDate: null,
  };

  loading: boolean = false;

  constructor(
    private readonly appAlertService: AppAlertService,
    private readonly insService: InstituationService,
    private readonly messageService: AppMessageService,
    private readonly translate: TranslateService,
    private readonly route: ActivatedRoute
  ) {
  }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['openSidebar'] === 'true') {
        this.insService.getById(params['instituationId']).subscribe(instituation => {
          this.initilize(instituation);
        })

      }
    });
  }

  async getList(event: TableLazyLoadEvent) {
    this.loading = true;
    const filterObj = {
      search: this.filter.search,
      searchBy: ['title', 'signboard'],
      'filter.isActive': this.filter.isActive,

      'filter.startDate': this.filter?.startDate
        ? `$gte:${this.filter.startDate.toISOString()}`
        : null,
      'filter.endDate': this.filter?.endDate
        ? `$lte:${this.filter.endDate.toISOString()}`
        : null,
    };

    this.insService.getFilter(event, filterObj).subscribe({
      next: (res) => {
        this.instituationList = res.items;
        this.totalRecords = res.total;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  clearFilter() {
    this.filter = {
      isActive: null,
      search: '',
      startDate: null,
      endDate: null,
    };
    this.getList({});
  }

  initilize(instituation?: any) {
    this.instituationComponent.initilize(instituation);
  }

  delete(id: number) {
    this.insService.delete(id).subscribe({
      next:(res) => {
        const index = this.instituationList.findIndex((elem) => elem.id === id);
        if (index > -1) {
          this.instituationList.splice(index, 1);
          this.totalRecords = this.totalRecords - 1;
        }

        this.messageService.successToast(
          this.translate.instant('common.success'),
          this.translate.instant('common.deleteSuccessToastMessage')
        );
      },
      error:(err) => {
        this.messageService.errorToast(
          this.translate.instant('common.error'),
          this.translate.instant('common.deleteErrorsToastMessage')
        );
      }
    });
  }

  deleteAlert(id: number) {
    this.appAlertService.sweetConfirm({
      header: this.translate.instant('Kurum'),
      message: `${this.translate.instant('kurum delete text')}`,
      showCloseButton: true, 
      accept: () => this.delete(id),
    });
  }

  onSave(event: any) {
    this.insService.getById(event?.id).subscribe((res) => {
      this.instituationList.push(res);
      this.totalRecords = this.totalRecords + 1;
    })
  }

  onUpdate(event: any) {
    const existingIndex = this.instituationList.findIndex((item) => item.id === event.id);
    if (existingIndex !== -1) {
      this.insService.getById(event?.id).subscribe((res) => {
        this.instituationList[existingIndex] = res;
      })
    }
  }
}
